<div class="md-sidebar">
  <a class="btn btn-primary md-sidebar-toggle" (click)="openMenu()"
    >email filter</a
  >
  <div class="md-sidebar-aside email-left-aside" [class.open]="open">
    <div class="card">
      <div class="card-body">
        <div class="email-app-sidebar">
          <!-- Compose Button -->
          <div class="compose-btn-wrapper">
            <a class="btn btn-primary btn-block" routerLink="/mail/compose">
              <i class="fa fa-plus me-2"></i>Ново съобщение
            </a>
          </div>
          <hr class="compose-divider" />
          <ul class="nav main-menu" role="tablist">
            <li class="nav-item">
              <a
                class="show"
                id="pills-darkprofile-tab"
                (click)="onNavigate(navigation.Inbox)"
                ><span class="title"><i class="icon-import"></i> Входящи</span
                ><span class="badge pull-right">({{inboxCount}})</span></a
              >
            </li>
            <li>
              <a (click)="onNavigate(navigation.OutBox)"
                ><span class="title"><i class="icon-new-window"></i> Изпратени</span
                ><span class="badge pull-right">({{outBoxCount}})</span></a
              >
            </li>
            <!--<li>
              <a href="javascript:void(0)"
                ><span class="title"><i class="icon-trash"></i> Изтрити</span
                ><span class="badge pull-right">(99)</span></a
              >
            </li>-->
            <li>
              <a (click)="onNavigate(navigation.StarredApplications)"
                ><span class="title"><i class="icon-star"></i> Отбелязани - Заявления</span>
                 <span class="badge pull-right">({{starredApplicationsCount}})</span></a
              >
            </li>
            <li>
              <a (click)="onNavigate(navigation.StarredOthers)"
                ><span class="title"><i class="icon-star"></i> Отбелязани - Други</span>
                 <span class="badge pull-right">({{starredOthersCount}})</span></a
              >
            </li>
            <li>
              <hr />
            </li>
            <li>
              <a (click)="onNavigate(navigation.UnRead)"
                ><span class="title"><i class="icon-email"></i> Непрочетени</span>
                 <span class="badge pull-right">({{NotReadCount}})</span></a
              >
            </li>
            <li>
              <a (click)="onNavigate(navigation.Read)"
                ><span class="title"><i class="icon-check"></i> Прочетени</span>
                 <span class="badge pull-right">({{readCount}})</span></a
              >
            </li>
          </ul>

          <!-- Custom Folders Section -->
          <ng-container *ngIf="customFolders && customFolders.length > 0">
            <hr class="folder-divider" />
            <div class="folder-section-header">
              <span class="folder-section-title">Папки</span>
            </div>
            <ul class="nav main-menu folder-menu" role="tablist">
              <li *ngFor="let folder of customFolders">
                <a (click)="onNavigateToFolder(folder.idMailFolder)"
                   [class.active]="selectedFolderId === folder.idMailFolder">
                  <span class="title"><i class="fa fa-folder"></i> {{folder.name}}</span>
                  <span class="badge pull-right">({{folder.messageCount}})</span>
                </a>
              </li>
            </ul>
          </ng-container>

          <!-- Folder Management Link -->
          <hr class="folder-divider" />
          <ul class="nav main-menu" role="tablist">
            <li>
              <a (click)="onOpenFolderManagement()" class="folder-management-link">
                <span class="title"><i class="fa fa-cog"></i> Управление на папки</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
